import React from 'react';
import { RadialBarChart, RadialBar, ResponsiveContainer } from 'recharts';
import styles from './RadialPercentageChart.module.css';
import Flex from '../Flex/Flex';
import Skeleton from '../Skeleton/Skeleton';

type RadialPercentageChartProps = {
    title?: string;
    percentage: number;
    label?: string;
    color?: string;
    backgroundColor?: string;
    height?: number;
    innerRadius?: string;
    outerRadius?: string;
    cornerRadius?: number;
    className?: string;
    percentageFormatter?: (value: number) => string;
    textColor?: string;
    isLoading?: boolean;
};

const RadialPercentageChart = ({
   title,
   percentage = 0,
   label = '',
   color = 'var(--primary-enabled)',
   backgroundColor = '#f3f4f6',
   height = 150,
   innerRadius = '75%',
   outerRadius = '100%',
   cornerRadius = 30,
   className = '',
   percentageFormatter = (value: number) => `${value.toFixed(2)}%`,
   textColor='var(--static-text-standard)',
   isLoading = false,
}: RadialPercentageChartProps) => {
    console.log('RadialPercentageChart', percentage);
    // Ensure percentage is between 0 and 100
    const normalizedPercentage = Math.min(Math.max(Math.abs(percentage), 0), 100);

    // Calculate angles
    const degrees = (normalizedPercentage * 180) / 100;
    const startAngle = 180;
    const endAngle = 180 - degrees;

    const data = [{
        name: label,
        value: normalizedPercentage,
        fill: color
    }];

    if (isLoading) {
        return (
            <div className={`${styles.loadingContainer}`}>
                <Flex direction='column' gap={4} style={{height: `100%`}}>
                    <Skeleton width='50%' height={60} />
                    <Skeleton width='100%' height={"100%"} />
                </Flex>
            </div>
        );
    }

    return (
        <div className={`${styles.container} ${className}`}>
            {title && <h3 className={styles.title}>{title}</h3>}
            <div className={styles.chartContainer} style={{ height }}>
                <ResponsiveContainer width="100%" height="100%">
                    <RadialBarChart
                        innerRadius={innerRadius}
                        outerRadius={outerRadius}
                        data={data}
                        startAngle={startAngle}
                        endAngle={endAngle}
                        cx="50%"
                        cy="50%"
                        margin={{ top: 0, right: 0, bottom: -25, left: 0 }}
                    >
                        <RadialBar
                            background
                            dataKey="value"
                            cornerRadius={cornerRadius}
                            fill={color}
                            // backgroundFill={backgroundColor}
                        />
                    </RadialBarChart>
                </ResponsiveContainer>
                <div
                    className={styles.percentageText}
                    style={{ color: textColor }}
                >
                    {percentageFormatter(percentage)}
                </div>
            </div>
        </div>
    );
};

export default RadialPercentageChart;